"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonStyled = exports.RadioButtonHidden = exports.Label = exports.GenericDiv = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = _styledComponents.default.label.withConfig({
  componentId: "sc-13cz1y4-0"
})(["cursor:pointer;vertical-align:top;display:inline-flex;flex-direction:row;align-items:center;line-height:1.1;", ""], function (_ref) {
  var typography = _ref.theme.typography;
  return "\n    font-size: ".concat(typography.fontSize, ";\n    font-weight: ").concat(typography.fontWeight, ";\n    font-family:  ").concat(typography.fontFamily[0], ";\n  ");
});

exports.Label = Label;

var RadioButtonHidden = _styledComponents.default.input.withConfig({
  componentId: "sc-13cz1y4-1"
})(["position:absolute;overflow:hidden;width:0;height:0;border:0;padding:0;margin:0;overflow:hidden;opacity:0;"]);

exports.RadioButtonHidden = RadioButtonHidden;

var RadioButtonStyled = _styledComponents.default.div.withConfig({
  componentId: "sc-13cz1y4-2"
})(["transition:0.2s all linear;flex-shrink:0;width:18px;height:18px;margin-right:12px;border-radius:100%;display:flex;justify-content:center;align-items:center;", ""], function (_ref2) {
  var color = _ref2.theme.color,
      checked = _ref2.checked;
  return "\n    border: 1px solid ".concat(checked ? color.primary : color.neutral400, ";\n\n    &:after {\n      content: '';\n      display: block;\n      width: 12px;\n      height: 12px;\n      background-color: ").concat(checked ? color.primary : color.ghost, ";\n      border-radius: 100%;\n    }\n  ");
});

exports.RadioButtonStyled = RadioButtonStyled;

var GenericDiv = _styledComponents.default.div.attrs(function (_ref3) {
  var margin = _ref3.theme.margin,
      marginTop = _ref3.marginTop,
      marginRight = _ref3.marginRight,
      marginBottom = _ref3.marginBottom,
      marginLeft = _ref3.marginLeft;
  return {
    marginTop: margin[marginTop] || margin.none,
    marginRight: margin[marginRight] || margin.none,
    marginBottom: margin[marginBottom] || margin.none,
    marginLeft: margin[marginLeft] || margin.none
  };
}).withConfig({
  componentId: "sc-13cz1y4-3"
})(["display:flex;", " ", ""], function (_ref4) {
  var color = _ref4.theme.color,
      dark = _ref4.dark,
      marginTop = _ref4.marginTop,
      marginRight = _ref4.marginRight,
      marginBottom = _ref4.marginBottom,
      marginLeft = _ref4.marginLeft;
  return "\n    margin: ".concat(marginTop, " ").concat(marginRight, " ").concat(marginBottom, " ").concat(marginLeft, ";\n    color: ").concat(dark ? color.neutral0 : color.neutral700, ";\n    &:hover {\n      ").concat(RadioButtonStyled, " {\n        border-color: ").concat(color.primary, ";\n      }\n    }\n  ");
}, function (_ref5) {
  var color = _ref5.theme.color,
      status = _ref5.status;
  return status === 'error' && "\n    ".concat(Label, " {\n      color: ").concat(color.danger, ";\n    }\n\n    ").concat(RadioButtonStyled, " {\n      border-color: ").concat(color.danger, ";\n    }\n  ");
});

exports.GenericDiv = GenericDiv;